import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-repository-folder-table', {
  mixins: [eventListenerMixin],

  connected() {
    this.table = this.querySelector('tr-table');
    this.toolbar = this.querySelector('tr-repository-folder-table-toolbar');
    this.listenTo(this.table, 'tr-table:selectedChange', this.handelSelectedChange.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  handelSelectedChange(e) {
    this.toolbar.selected = e.detail.map(r => r.dataset.gid);
  },
});
